export default __webpack_public_path__ + "media/images/images_v2/iui/whiteButton-fc8e42da3b9dfe789f68c21e689cfbab.png";